import { AuthProvider } from '@/context/AuthContext'
import { CartProvider } from '@/context/Cart'
import { ContentProvider } from '@/context/ContentContext'
import { ThemeProvider } from '@/context/ThemeContext'
import { LanguageProvider } from '@/context/LanguageContext'
import { ToastProvider } from '@/context/ToastContext'
import { GetAppProvider } from '@/context/GetAppContext'
import createEmotionCache from '@/createEmotionCache'
import '@/styles/globals.css'
import { CacheProvider, EmotionCache } from '@emotion/react'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { AppProps } from 'next/app'
import Head from 'next/head'
import * as React from 'react'
import Layout from '../layouts'
import theme from '../styles/theme'
import TagManager from 'react-gtm-module'
// import VwoScript from '@/components/scripts/vwoScript'
import MazeScript from '@/components/scripts/maze'

// Client-side cache, shared for the whole session of the user in the browser.
const clientSideEmotionCache = createEmotionCache()

export interface MyAppProps extends AppProps {
  emotionCache?: EmotionCache
}

const MyApp: React.FC<MyAppProps> = (props) => {
  const { Component, emotionCache = clientSideEmotionCache, pageProps } = props
  // const { setTheme } = useTheme()

  React.useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      TagManager.initialize({ gtmId: 'GTM-WHN74TKC' })
    }
    // const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches

    // const selectedTheme = localStorage.getItem('theme')
    // if (selectedTheme !== null) {
    //   document.body.classList.add(selectedTheme)
    //   // setTheme(selectedTheme)
    // } else if (prefersDarkMode) {
    //   document.body.classList.add('dark')
    //   // setTheme('dark')
    // } else {
    //   document.body.classList.add('light')
    //   // setTheme('light')
    // }
  }, [])

  return (
    <CacheProvider value={emotionCache}>
      <Head>
        <title>Мобиком Корпораци</title>
        <meta property='fb:pages' content='105701022801307' />
        <meta name='viewport' content='initial-scale=1, width=device-width' />
        <meta name='keywords' content='Мобиком, Mobicom, гар утас, үүрэн холбоо, интернэт, 3G, 4G, LTE, харилцаа холбоо, роуминг, сансрын холбоо, контент, wi-fi, mongolian mobile, operator, үүрэн холбоо, mobile network, Mongolia broadband, ict, тэмүүлэл, mongolian wireless provider, mongolian communications, mongolian telco, mongolia mobile operator, mongolia broadband, mongolia wimax' />
        <meta name='description' content='Монголын анхны үүрэн холбооны оператор' />
        <meta content='https://www.mobicom.mn/images/logo_mobicom.png' property='og:image' />
        <meta name='google-site-verification' content='CjnjTQqUgLgXWBPJ_ZilEPiWLwJoaH9GSWp9ND907qY' />
      </Head>
      <MuiThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <LanguageProvider>
          <AuthProvider>
            <ThemeProvider>
              <ToastProvider>
                <ContentProvider>
                  <CartProvider>
                    <GetAppProvider>
                      <Layout>
                        <MazeScript />
                        <Component {...pageProps} />
                      </Layout>
                    </GetAppProvider>
                  </CartProvider>
                </ContentProvider>
              </ToastProvider>
            </ThemeProvider>
          </AuthProvider>
        </LanguageProvider>
      </MuiThemeProvider>
    </CacheProvider>
  )
}

export default MyApp
